import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

export function EmptyApplicationsState() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="flex items-end gap-1 mb-6 h-8">
        {[0, 1, 2, 3, 4].map(i => (
          <span key={i} className="voice-wave-bar" style={{ animationDelay: `${i * 0.12}s` }} />
        ))}
      </div>
      <h3 className="font-display text-lg text-cj-green-dark mb-2">
        {t('dashboard.applications.empty.title')}
      </h3>
      <p className="text-sm text-muted-foreground mb-6 max-w-xs">
        {t('dashboard.applications.empty.description')}
      </p>
      <button
        onClick={() => navigate('/jobs')}
        className="rounded-2xl bg-cj-orange px-5 py-2.5 text-sm font-semibold text-black transition-colors hover:brightness-95"
      >
        {t('dashboard.applications.empty.cta')}
      </button>
    </div>
  );
}
